import { useState } from "react";
import { useContext } from "react";
import {
  Textareawithsteroids,
  Textareawithsteroids2,
} from "../ESG/EnvironmentReport";
import { HeaderShow } from "../ESG/ESGmain";
import { RelevantGoals } from "./SDGmain";
const Step1 = () => {
  const { relevantGoals } = useContext(RelevantGoals);
  const [showContent, setShowContent] = useState(false);
  const subtext = `To Goal-wash is to take existing activities in the company and then place these into most possible goals. To avoid "Goal-washing" you have to work seriously and strategically with one or more goals and not least have defined how to measure your progress over time

To do this you need to know the content of each of the 12 overall themes, which is described in the subgoals.`;
  const actiontext =
    "Read the next section, then read the subgoals and note down which youc an concretely influence";
  const exercisetext =
    "Discuss the goals and what concrete action could be in groups/departments or th elike in the corporation.";
  return (
    <div className="d-flex flex-column align-items-center">
      <HeaderShow
        text={"Step 1 Understand"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <div className="roleambition__bubble w-90 mt-3 ms-0">
          <h5>{subtext}</h5>
          <div className="d-flex justify-content-between mt-2">
            <div className="d-flex flex-column me-5">
              <h5 style={{ textAlign: "center" }}>
                <b>Action</b>
              </h5>
              <h5>{actiontext}</h5>
            </div>
            <div className="d-flex flex-column">
              <h5 style={{ textAlign: "center" }}>
                <b>Exercise</b>
              </h5>
              <h5>{exercisetext}</h5>
            </div>
          </div>
        </div>
      ) : null}
      {showContent &&
        Array.isArray(relevantGoals) &&
        relevantGoals?.map((goal) => {
          return (
            <div className="d-flex flex-column w-90 mt-3">
              <h4 className="esg__companyinfo w-100">
                {goal?.key && goal?.key.replace("_", " ")} : {goal.title}
              </h4>
              <div className="d-flex align-items-center justify-content-around">
                <div className="sdg__action__exercise">
                  <h4>Action:</h4>
                  <Textareawithsteroids2
                    maxLength={3000}
                    keyHighlight={"step1_action"}
                  />
                </div>
                <div className="sdg__action__exercise">
                  <h4>Exercise:</h4>
                  <Textareawithsteroids2
                    maxLength={3000}
                    keyHighlight={"step1_exercise"}
                  />
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Step1;
